import { BaseRepository } from '../BaseRepository';
import { BFF_ENDPOINTS } from '../../endpoints/BffEndpoints';
import { BffAuthenticatedApiClient } from '../../clients/BffAuthenticatedApiClient';
import type { HttpResponse } from '../../http/HttpClient';
import type { WorkflowResponse } from '../../models/bff/Workflow';

const NAME = 'workflow';

// Workflow polling retry configuration
const MAX_RETRY_ATTEMPTS = 10;
const INITIAL_RETRY_DELAY_MS = 500;
const RETRY_BACKOFF_BASE = 2;
const MAX_BACKOFF_EXPONENT = 5;
const HTTP_REQUEST_TIMEOUT = 408;

/**
 * Repository for workflows-related operations.
 */
export class WorkflowRepository extends BaseRepository {
  static override readonly name = NAME;

  constructor() {
    super(BffAuthenticatedApiClient.getInstance());
  }

  checkStatus(id: string): Promise<HttpResponse<WorkflowResponse>> {
    return this.apiClient.get<WorkflowResponse>(
      BFF_ENDPOINTS.WORKFLOW_STATUS,
      {
        pathParams: {
          workflowId: id,
        },
        retry: MAX_RETRY_ATTEMPTS,
        retryDelay: (context) => {
          // exponential backoff
          const attemptsRemaining = context.options.retry as number;
          const attempt = MAX_RETRY_ATTEMPTS - attemptsRemaining;
          return INITIAL_RETRY_DELAY_MS * Math.pow(RETRY_BACKOFF_BASE, Math.min(attempt, MAX_BACKOFF_EXPONENT));
        },
        retryStatusCodes: [HTTP_REQUEST_TIMEOUT],
      },
    );
  }
}

declare module '../Repositories' {
  export interface Repositories {
    [NAME]: WorkflowRepository;
  }
}